import React from "react";
import { isMobile } from "react-device-detect";
import { Grid, Skeleton } from "@mui/material";

export function FundraisersListSkeleton() {
    return <Grid container justifyContent="space-between" spacing={{xs: 0, sm: 4}} sx={styles.container}>
        {[...Array(6)].map((value, index) => {
            return <Grid key={index} item xs={5.5} sm={4} sx={styles.item}>
                <div className="box">
                    <div className="card1">
                        <div className="card-top-por">
                            <div className="card-main-img">
                                <div className="bg-picture"
                                    alt="Responsive image img-fluid">
                                    <Skeleton height={200} variant="rectangular" />
                                </div>
                            </div>
                        </div>
                        <div className="card-content">
                            <div className="cardmeta">
                                <Skeleton width={ isMobile ? 150 : 300} />
                                <div className="donorinfo">
                                    <div className="left">
                                        <Skeleton height={30} variant="rectangular" />
                                    </div>
                                    <div className="right">
                                    <Skeleton width={100} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Grid>
        })}
        {/* Added the following item to balance the UI if a row contains two records */}
        <Grid item xs={5.5} sm={3.5}></Grid>
    </Grid>
}

const styles = {
    container: {
        gap: isMobile ? '5px' : 'unset'
    },
    item: {
        maxWidth: isMobile ? 'calc(50% - 2.5px)' : 'unset'
    },
}